import React from "react";

import { useTeamSettings } from "./hooks/useTeamSettings";

import TeamHeader from "./components/TeamHeader";
import TeamKpiCards from "./components/TeamKpiCards";
import TeamFiltersCard from "./components/TeamFiltersCard";
import TeamTable from "./components/TeamTable";
import TeamFormDrawer from "./components/TeamFormDrawer";

export default function SettingsTeam() {
  const dashboard = useTeamSettings();

  return (
    <div className="space-y-5">
      <TeamHeader onCreate={dashboard.openCreateDrawer} />

      <TeamKpiCards
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
        loading={dashboard.loading}
      />

      <TeamFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        categories={dashboard.categories}
        filteredCount={dashboard.filteredTeam.length}
        totalCount={dashboard.team.length}
        loading={dashboard.loading}
        onRefresh={dashboard.fetchTeamMembers}
      />

      <TeamTable
        team={dashboard.filteredTeam}
        loading={dashboard.loading}
        deletingId={dashboard.deletingId}
        reordering={dashboard.reordering}
        onEdit={dashboard.openEditDrawer}
        onDelete={dashboard.handleDeleteTeamMember}
        onMoveUp={(member) => dashboard.moveTeamMember(member.id, "up")}
        onMoveDown={(member) => dashboard.moveTeamMember(member.id, "down")}
      />

      <TeamFormDrawer
        isOpen={dashboard.formDrawerOpen}
        mode={dashboard.formMode}
        member={dashboard.editableMember}
        nextPosition={dashboard.nextPosition}
        submitting={dashboard.submittingForm}
        uploadProgress={dashboard.uploadProgress}
        onClose={dashboard.closeFormDrawer}
        onSubmit={dashboard.handleSubmitTeamMember}
      />
    </div>
  );
}